import createModel from 'utils/model'
// eslint-disable-next-line no-unused-vars
import {getDetails, createContactMe, editContactMe} from 'crm/services/drainage-contact-me'

export default createModel({
    namespace: 'crm_createContactMe',

    state: {
        details: {},
    },

    effects: {
        // eslint-disable-next-line no-unused-vars
        *getDetails({payload}, {call, put}) {
            const res = yield call(getDetails, {id: payload?.id})

            if (res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        details: res.data,
                    },
                })
            }

            return res
        },

        *createContactMe({payload}, {call}) {
            return yield call(createContactMe, payload)
        },

        *editContactMe({payload}, {call}) {
            return yield call(editContactMe, payload)
        },
    },
})
